import { HistoryList } from "~/client/components/search/HistoryList";
import { useCloseByKey } from "~/client/components/search/hooks/useCloseByKey";
import { useNoteBrowsingHistory } from "~/client/components/search/hooks/useNoteBrowsingHistory";
import { useSearchHistory } from "~/client/components/search/hooks/useSearchHistory";

interface Props {
  onSearch(): void;
  onClose(): void;
}
export const HistoryListContainer: React.FC<Props> = ({ onSearch, onClose }) => {
  useCloseByKey(onClose);

  const searchHistory = useSearchHistory();
  const noteBrowsingHistory = useNoteBrowsingHistory();

  return <HistoryList onSearch={onSearch} searchHistory={searchHistory} noteBrowsingHistory={noteBrowsingHistory} />;
};
